import { render, staticRenderFns } from "./lump-funding-footer.vue?vue&type=template&id=16bd4f89&scoped=true"
import script from "./lump-funding-footer.vue?vue&type=script&lang=js"
export * from "./lump-funding-footer.vue?vue&type=script&lang=js"
import style0 from "./lump-funding-footer.vue?vue&type=style&index=0&id=16bd4f89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bd4f89",
  null
  
)

export default component.exports